import Vue from "vue"

Vue.filter("formatArea", function (value) {
  if (value) {
    return Math.round(value).toLocaleString("es")
  }
})

Vue.filter("areaToHA", function (value) {
  if (!value) return ""
  value = value / 10000
  return value.toFixed(2).toLocaleString("es")
})

Vue.filter("nl2p", function (value) {
  if (value) {
    return "<p>" + value.replace("\n", "</p><p>") + "</p>"
  }
})

Vue.filter("localize", function (value) {
  if (value) {
    return new Date(value).toLocaleDateString("es")
  }
})
